"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MenuItem_1 = require("./MenuItem");
exports.default = MenuItem_1.default;
//# sourceMappingURL=index.js.map